
import React, { useEffect, useState } from "react";
import MyNavbar from "../navbar";
import Customermenu from "./Customermenu";
import Footer from "../footer";
import Customerbanner from "./Customerbanner";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Scrolltotopbtn from "../Scrolltotopbutton";
import Notification from "../Notification";
import { jsPDF } from "jspdf"; 
import { firstImage } from "../../parseImages";

export default function Orders() {
  const [allProducts, setAllProducts] = useState([]);
  const [notification, setNotification] = useState(null);
  


    
  // }, []);

  
  useEffect(() => {
    // Fetch all orders for the current user
    axios
      .get(`${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/totalordersdetails`)
      .then((res) => {
        if (res.data !== "Fail" && res.data !== "Error") {
          const userOrders = res.data.filter((item) => item.buyer_id === parseInt(localStorage.getItem("user-token")));

          // Fetch seller details for each product
          const updatedProducts = userOrders.map((product) => {
            return axios
              .post(`${process.env.REACT_APP_HOST}${process.env.REACT_APP_PORT}/users`, { sellerID: product.seller_id })
              .then((res) => {
                if (res.data !== "Error" && res.data !== "Fail") {
                  const sellerInfo = res.data;
                  // Add seller info to the product
                  return { ...product, sellerDetails: sellerInfo };
                }
              })
              .catch((error) => {
                // console.error("Error fetching seller details:", error);
                return { ...product, sellerDetails: null };
              });
          });

          // Once all seller details are fetched, update the state
          Promise.all(updatedProducts).then((productsWithSellerDetails) => {
            setAllProducts(productsWithSellerDetails);
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching all products:", error);
      });
  }, []);


  // Filter orders for the current user

  // Map each order to its corresponding product
  

  const navigate = useNavigate(); // Hook to navigate programmatically

  const cancelClick = (product) => {
    // Check if the product has been shipped
    if (product.shipped_date) {
      // alert("You cannot cancel this product as it has already been shipped.");
      setNotification({ message: 'You cannot cancel this product as it has already been shipped.', type: 'error' });
      setTimeout(() => setNotification(null), 3000);
      return;
    }

    // Navigate to the request cancel page with product details
    navigate("/cancelorder", { state: { filteredProducts: product } });
  };

  const downloadInvoice = (product) => {
    const doc = new jsPDF();
    let yPos = 20; // Initial starting position
    const sellerInfo = product.sellerDetails && Array.isArray(product.sellerDetails) && product.sellerDetails.length > 0 ? product.sellerDetails[0] : null;
    // Safely access the shopname, phone, and email, with fallback values
    const shopname = sellerInfo ? (sellerInfo.shopname || `${sellerInfo.firstname} ${sellerInfo.lastname}`) : "Unknown Shop";
    const phone = sellerInfo ? sellerInfo.phone : "Not Available";  // Fallback value
    const email = sellerInfo ? sellerInfo.email : "Not Available";  // Fallback value
    
    // Add Shop Information (Header)
    doc.setFontSize(16);
    doc.text(shopname, 14, yPos); // Shop Name
    yPos += 10; // Move down
    
    // doc.setFontSize(12);
    // doc.text('Company Address: 123 Your Street, Your City, Your Country', 14, yPos);
    // yPos += 10;
    
    doc.text('Phone: ' + phone, 14, yPos); // Display Phone
    yPos += 10;
    
    doc.text('Email: ' + email, 14, yPos); // Display Email
    yPos += 10;
    
    doc.setLineWidth(0.5);
    doc.line(14, yPos, 200, yPos);  // Horizontal line
    yPos += 10;
    
    doc.text('Invoice', 14, yPos);  // Title
    yPos += 10;  // Add space after title

    // Add Invoice Date and Order ID
    doc.setFontSize(10);
    const orderedDate = new Date(product.ordered_date);

    // Check if it's a valid date
    if (!isNaN(orderedDate)) {
        doc.text('Invoice Date: ' + orderedDate.toLocaleDateString("fr-CA"), 14, yPos);
    } else {
        // Handle the case where ordered_date is not valid
        doc.text('Invoice Date: Invalid Date', 14, yPos);
    }    yPos += 10;
    doc.text('Order ID: ' + product.order_id, 14, yPos);
    yPos += 10;
    doc.text('Order Status: ' + product.order_status, 14, yPos);

    yPos += 20; // Add space for next section

    // Customer, Billing, and Shipping Details Section (Same Line)
    doc.setFontSize(12);
    
    // **Customer Details** on the left side
    doc.text('Customer Details:', 14, yPos); 
    doc.setFontSize(10);
    doc.text(`Name: ${product.firstname}`, 14, yPos + 10); 
    doc.text(`Address: ${product.address1}`, 14, yPos + 20);  
    doc.text(`Contact: ${product.phone}`, 14, yPos + 30);  
    
    // **Billing Details** in the middle
    doc.text('Billing Details:', 90, yPos); // Billing title
    doc.setFontSize(10);
    doc.text(`Name: ${product.firstname}`, 90, yPos + 10); // Billing Name
    doc.text(`Address: ${product.address1}`, 90, yPos + 20); // Billing Address
    doc.text(`Contact: ${product.phone}`, 90, yPos + 30); // Billing Contact

    // **Shipping Details** on the right side
    doc.text('Shipping Details:', 160, yPos); // Shipping title
    doc.setFontSize(10);
    doc.text(`Name: ${product.firstname}`, 160, yPos + 10); // Shipping Name
    doc.text(`Address: ${product.address1}`, 160, yPos + 20); // Shipping Address
    doc.text(`Contact: ${product.phone}`, 160, yPos + 30); // Shipping Contact
    
    // Add line after details
    doc.setLineWidth(0.5);
    doc.line(14, yPos + 40, 200, yPos + 40);  // Horizontal line
    yPos += 50;  // Move down to next section

    // Product Details Section
    doc.setFontSize(12);
    doc.text('Product Details:', 14, yPos);
    yPos += 10;
    
    doc.setFontSize(10);
    doc.text('Description', 14, yPos);  // Column name for product description
    doc.text('Quantity', 100, yPos);  // Column name for quantity
    doc.text('Unit Price', 140, yPos);  // Column name for unit price
    doc.text('Total', 180, yPos);  // Column name for total price
    yPos += 10;
    
    doc.setLineWidth(0.5);
    doc.line(14, yPos, 200, yPos);  // Horizontal line
    yPos += 10;

    // Product Row(s)
    doc.text(product.name, 14, yPos);  // Product name
    doc.text(product.order_quantity.toString(), 100, yPos);  // Quantity
    doc.text(`${product.currency === "INR" ? '₹' : '$'}${product.order_amount}`, 140, yPos);  // Unit Price
    doc.text(`${product.currency === "INR" ? '₹' : '$'}${(product.order_amount)}`, 180, yPos);  // Total Price

    yPos += 15;

    // Total Price Section
    doc.setLineWidth(0.5);
    doc.line(14, yPos, 200, yPos);  // Horizontal line
    yPos += 10;

    // Shipping and GST are folded into rupee prices only. Dollar orders are
    // billed the product price alone, so the invoice must not add either.
    const isRupeeOrder = product.currency === "INR";
    let subTotal = product.price * product.order_quantity;
    let shippingFee = isRupeeOrder ? 40 * product.order_quantity : 0;
    let taxes = isRupeeOrder ? Math.round((subTotal + shippingFee) * 0.18) : 0;


    doc.text(`Subtotal: ${product.currency === "INR" ? '₹' : '$'}${subTotal}`, 14, yPos);
    yPos += 10;
    if (isRupeeOrder) {
      doc.text(`Taxes (18%): ₹${taxes}`, 14, yPos);
      yPos += 10;
      doc.text(`Shipping Fee: ₹${shippingFee}`, 14, yPos);
    } else {
      doc.text('Shipping Fee: FREE (introductory offer)', 14, yPos);
    }
    
    yPos += 10;
    doc.setLineWidth(0.5);
    doc.line(14, yPos, 200, yPos);  // Horizontal line
    yPos += 10;
    doc.text(`Total Amount: ${product.currency === "INR" ? '₹' : '$'}${(product.order_amount)}`, 14, yPos);

    
    yPos += 10;

    // Payment Method Section
    doc.setLineWidth(0.5);
    doc.line(14, yPos, 200, yPos);  // Horizontal line
    const paymentMethod = product.payment_method || "Card"; // Fallback to "Card"
    doc.text('Payment Method: ' + paymentMethod, 14, yPos + 10);
    
    yPos += 18;  // Add space after payment method

    // Footer Section
    doc.setFontSize(10);
    doc.text('Thank you for shopping with us!', 14, yPos);
    doc.text('For any queries, please contact our support team.', 14, yPos + 10);

    // Save the PDF
    doc.save(`invoice_${product.order_id}.pdf`);
};




  return (
    <div className="fullscreen">
      <MyNavbar />
      {notification && <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />}

      <main>
        <Customerbanner />

        <div className="d-lg-flex justify-content-around p-2 ps-lg-5 pe-lg-5">
          <div className="col-lg-3 col-xs-12 col-md-12 p-lg-4 p-2">
            <Customermenu />
          </div>

          <div className="col-xs-12 col-md-12 col-lg-9 p-lg-4 p-2">
            {allProducts.length > 0 ? (
              <div className="table-responsive" 
              style={{
                // maxHeight: allProducts.length > 5 ? '400px' : 'none', // Apply scroll only if more than 5 rows
                // overflowY: allProducts.length > 5 ? 'auto' : 'visible', // Enable scroll only if more than 5 rows
              }}

              >
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Product Image</th>
                      <th>Product Name</th>
                      <th>Total Price</th>
                      <th>Action</th>
                      <th>Invoice</th> 
                    </tr>
                  </thead>

                  <tbody
                 
                  
                  >
                    {allProducts.map((product, index) => (
                      <tr key={index}>
                        <td style={{ minWidth: "120px" }}>
                          {product.order_status === 'cancelled' ? (
                            <img
                              src={`${firstImage(product.image, 'defaultImagePath')}`}
                              alt={product.name}
                              style={{ maxWidth: "60px", maxHeight: "100px" }}
                            />
                          ) : (
                            <Link
                              to="/orderpage"
                              state={{ filteredProducts: product }}
                              style={{ textDecoration: 'none', color: 'inherit' }}
                            >
                              <img
                                src={`${firstImage(product.image, 'defaultImagePath')}`}
                                alt={product.name}
                                style={{ maxWidth: "60px", maxHeight: "100px" }}
                              />
                            </Link>
                          )}
                        </td>

                        <td className="text-secondary pt-3" style={{ minWidth: "170px" }}>
                          {product.name}
                        </td>
                       
                        <td className="pt-3" style={{ minWidth: "100px" }}>
                       {product.currency === "INR" ? (
                            <>
                              &#8377;{" "}
                              {product.order_amount}{" "}

                              {/* {parseFloat((product.order_amount * product.order_quantity)).toFixed(2)}{" "} */}
                              {/* INR */}
                            </>
                          ) : (
                            <>
                              &#36;{" "}
                              {product.order_amount}{" "}

                              {/* {parseFloat((product.order_amount * product.order_quantity)).toFixed(2)}{" "} */}
                              {/* USD */}
                            </>
                          )}
                        </td>
                        <td className="pt-3" style={{ minWidth: "100px" }}>
                          {product.order_status === 'cancelled' ? (
                            <span className="text-danger">Cancelled</span>
                          ) : product.delivered_date === null ? (
                            <button
                              className="btn btn-danger"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation(); // Prevent Link click event
                                cancelClick(product);
                              }}
                            >
                              Order Cancel
                            </button>
                          ) : (
                            <Link 
                              to="/feedback" 
                              state={{ filteredProducts: product }} 
                              className="text-decoration-none"
                            >
                              <i className="bi bi-star-fill"></i>&nbsp; Rate & Review Product
                            </Link>
                          )}
                        </td>
                        <td className="pt-3">
                          <button 
                            className="btn btn-info" 
                            onClick={() => downloadInvoice(product)}>
                            Download Invoice
                          </button>
                        </td>
                      </tr>
                    ))}
                    
                  </tbody>
                </table>
              </div>
            ) : (
              <h1 style={{ fontSize: "20px" }}>No orders</h1>
            )}
          </div>
        </div>
      </main>
      <Footer />
      <Scrolltotopbtn/>
    </div>
  );
}
